<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" v-model="selectedItems" :items="data.list" :loading="query.loading"
				class="elevation-1" disable-pagination hide-default-footer item-key="id"
				loading-text="正在加载,请稍候......">
				<template v-slot:top>
					<v-row dense class="mb-n5">
						<v-col cols="12" class="d-flex flex-wrap mt-2 ml-2">
							<div style="width: 200px;" class="mr-1">
								<v-select :items="selectClassList" v-model="query.classId" item-text="className"
									item-value="id" label="班级" dense outlined clearable></v-select>
							</div>
							<div style="width: 200px;" class="mr-1">
								<v-select :items="selectTeacherList" v-model="query.teacher" item-text="trueName"
									item-value="id" label="老师" dense outlined clearable></v-select>
							</div>
							<!-- <div style="width: 200px;" class="mr-1">
								<v-select :items="selectClassroomList" v-model="query.roomId" item-text="roomName"
									item-value="id" label="教室" dense outlined clearable></v-select>
							</div> -->
							<studentSearchBox @inputValue="setInputValue"></studentSearchBox>
							<div style="width: 150px;" class="mr-1">
								<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
									transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="上课开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn">
								
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 150px;" class="mr-1">
								<v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="上课结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn">
								
									</v-date-picker>
								</v-menu>
							</div>
							<div style="width: 150px;" class="mr-1">
								<v-select :items="statusItems" v-model="query.status" item-text="statusName" item-value="id"
									label="到课状态" dense outlined></v-select>
							</div>
							<div style="width: 150px;" class="mr-1">
								<v-select :items="bukeItems" :disabled="query.status=='1'" v-model="query.isBuke" item-text="text" item-value="id"
									label="是否补课" dense outlined></v-select>
							</div>
							<div style="width: 120px;" class="mr-1">
								<v-select :items="rateItems" v-model="query.isRate" item-text="rateName" item-value="id"
									label="是否评论" dense outlined></v-select>
							</div>
							<div style="width: 120px;" class="mr-1">
								<v-select :items="giveItems" v-model="query.isGive" item-text="name" item-value="id"
									label="是否奖励" dense outlined></v-select>
							</div>
							<v-btn @click="queryClicked" color="primary">查询</v-btn>
						</v-col>
						

					</v-row>
					<v-divider></v-divider>
				</template>
				<template v-slot:item.status="{item}">
					<span v-if="item.status==='1'">到课</span>
					<span v-if="item.status==='2'" style="color:red">请假</span>
					<span v-if="item.status==='3'" style="color:red">旷课</span>
				</template>
				<template v-slot:item.studentType="{item}">
					<span v-if="item.studentType==='1'">固定学员</span>
					<span v-if="item.studentType==='2'" style="color:green">预约学员</span>
					<span v-if="item.studentType==='3'" style="color:red">插班补课</span>
				</template>
				<template v-slot:item.reduceAmount="{item}">
					<span v-if="item.consumeType==='1'">-</span>
					<span v-if="item.consumeType==='2'">{{item.reduceAmount}}</span>
				</template>
				<template v-slot:item.isRate="{item}">
					<template v-if="item.status == '1'">
						<span v-if="item.isRate === '1'">已点评</span>
						<span v-if="item.isRate === '0'" style="color:#F50057">未点评</span>
					</template>
					<template v-else>
						<span>-</span>
					</template>
				</template>
				<template v-slot:item.isGivePoint="{item}">
					<template v-if="item.status == '1'">
						<span v-if="item.isGivePoint === '1'">已奖励</span>
						<span v-if="item.isGivePoint === '0'" style="color:#F50057">未奖励</span>
					</template>
					<template v-else>
						<span>-</span>
					</template>
				</template>
				<template v-slot:item.isBuke="{item}">
					<template v-if="item.status !== '1'">
						<span v-if="item.isBuke === '1'">已补</span>
						<span v-if="item.isBuke === '0'" style="color:#F50057">未补</span>
					</template>
					<template v-else>
						<span>-</span>
					</template>
				</template>
				<template v-slot:item.action="{item}">
					<v-menu bottom>
						<template v-slot:activator="{ attrs, on }">
							<v-btn color="teal lighten-1" v-bind="attrs" v-on="on" small dark height="30px">
								操作
							</v-btn>
							
						</template>
						<v-list>
							<v-list-item class="justify-center">
								<v-btn @click.stop="showRateDialog(item)" :disabled="item.isRate !== '0' || item.status !=='1'" color="info" small>
									课堂点评
								</v-btn>
							</v-list-item>
							<v-list-item class="justify-center">
								<v-btn @click.stop="showGivePointDialog(item)" :disabled="item.isGivePoint !== '0' || item.status !=='1'" color="success" small>
									奖励积分
								</v-btn>
							</v-list-item>
							<v-list-item class="justify-center">
								<v-btn @click.stop="showBukeDialog(item)" :disabled="item.status === '1'  || item.isBuke !=='0'" color="success" small>
									插班补课
								</v-btn>
							</v-list-item>
						</v-list>
					</v-menu>
					
				</template>

			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="2">
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9" v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

		<!-- 奖励积分组件 -->
		<giveStudentPoint :show="givePoint.dialog" :detailId="givePoint.detailId" :studentName="givePoint.studentName"
			@cancel="givePoint.dialog=false" @success="givePointSuccess"></giveStudentPoint>
		<!-- 点评组件 -->
		<rateStudentClass :show="rate.show" :detailId="rate.detailId" :studentName="rate.studentName" 
			@cancel="rate.show=false" @success="rateSuccess"></rateStudentClass>
		
		<!-- 补课组件 -->
		<makeUpMissedLesson :show="buke.show" :recordDetail="buke.recordDetail"
			@cancel="buke.show=false" @success="bukeSuccess"></makeUpMissedLesson>
	</v-card>
</template>

<script>
	import utils from "../../../config/utils"
	import giveStudentPoint from "../../../components/give_student_point.vue"
	import rateStudentClass from "../../../components/rate_student_class.vue"
	import makeUpMissedLesson from "../../../components/make_up_missed_lesson.vue"
	import studentSearchBox from "../../../components/student_search_box.vue"
	export default {
		name: "class-record-detail-list",
		components:{giveStudentPoint,rateStudentClass,makeUpMissedLesson,studentSearchBox},
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				selectedItems: [], //选中的行
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '教务中心',
						disabled: true
					},
					{
						text: '点名记录',
						disabled: true
					},
				],
				data: {
					total: 0,
					headers: [
						{
							text: '上课时间',
							value: 'classDate',
							sortable: false,
								
						},
						{
							text: '课程',
							value: 'courseName',
							sortable: false,
						},
						{
							text: '班级',
							value: 'className',
							sortable: false,
						},
						{
							text: '主课老师',
							value: 'teacherName',
							sortable: false,
						},
						{
							text: '教室',
							value: 'roomName',
							sortable: false,
						},
						{
							text: '学员姓名',
							value: 'studentName',
							sortable: false,
						},
						{
							text: '学员类型',
							value: 'studentType',
							sortable: false,
						},
						{
							text: '上课状态',
							value: 'status',
							sortable: false,
						},
						{
							text: '扣课时',
							value: 'reduceQty',
							sortable: false,
						},
						{
							text: '扣学费',
							value: 'reduceAmount',
							sortable: false,
						},
						{
							text: '是否点评',
							value: 'isRate',
							sortable: false,
			
						},
						{
							text: '奖励积分',
							value: 'isGivePoint',
							sortable: false,
				
						},
						{
							text: '是否补课',
							value: 'isBuke',
							sortable: false,
										
						},
						{
							text: '操作',
							value: 'action',
							align:'center',
							sortable: false
						},
					],
					list: [],
				},
				selectCourseList: [], //选择课程数据源
				selectClassList: [], //选择课程数据源
				selectTeacherList: [], //选择老师数据源
				selectClassroomList: [], //选择教室数据源
				statusItems: [{
						id: "",
						statusName: "全部"
					},
					{
						id: "1",
						statusName: "到课"
					},
					{
						id: "5",
						statusName: "缺课"
					},
					{
						id: "2",
						statusName: "请假"
					},
					{
						id: "3",
						statusName: "旷课"
					},
				],
				rateItems: [{
						id: "",
						rateName: "全部"
					},
					{
						id: "0",
						rateName: "未点评"
					},
					{
						id: "1",
						rateName: "已点评"
					},
				],
				bukeItems:[
					{id:"",text:"全部"},
					{id:"0",text:"未补"},
					{id:"1",text:"已补"},
				],
				giveItems:[
					{id:"",name:"全部"},
					{id:"0",name:"未奖励"},
					{id:"1",name:"已奖励"}
				],
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
					shopId: "",
					classId: "",
					roomId: "",
					teacher: "",
					status: "",
					isRate:"",
					isGive:"",
					isBuke:"",
					studentName:""
				},
				
				givePoint: {
					dialog: false,
					studentName: "",
					detailId: "",
				},
				rate:{
					// 点评组件控制参数
					show:false,
					detailId:"",
					studentName:""
					
				},
				buke:{
					show:false,
					recordDetail:null
				}
				
			}
		},
		created() {
			const shopId = utils.getCurrentShopId();
			
			this.getClassListForSelect(shopId);
			this.getTeacherListForSelect(shopId);
			this.getClassroomListForSelect(shopId);
			
			this.getTableDataList();
		},
		methods: {
			
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			
			showRateDialog(item) {
				
				this.rate.show = true;
				this.rate.detailId = item.id;
				this.rate.studentName = item.studentName;

			},
			rateSuccess(){
				// 点评成功的回调
				this.rate.show = false;
				this.getTableDataList();
			},
			showGivePointDialog(item) {
				
				// 显示积分奖励组件
				this.givePoint.dialog = true;
				this.givePoint.detailId = item.id;
				this.givePoint.studentName = item.studentName;
				
			
			},
			givePointSuccess(){
				// 奖励积分成功
				this.givePoint.dialog= false;
				this.getTableDataList();
			},
			showBukeDialog(item){
				this.buke.recordDetail = item;
				this.buke.show = true;
			},
			bukeSuccess(){
				this.buke.show = false;
				this.getTableDataList();
			},
			setInputValue(value){
				// 搜索框输入的值
			
				this.query.studentName = value;
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;

				const shopId = utils.getCurrentShopId();

				let url = `/edu/class/record/detail/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.classId) {
					url += "&classId=" + this.query.classId;
				}
				
				if (this.query.roomId) {
					url += "&roomId=" + this.query.roomId;
				}
				if (this.query.teacher) {
					url += "&teacher=" + this.query.teacher;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				if (this.query.isRate) {
					url += "&isRate=" + this.query.isRate;
				}
				if (this.query.isGive) {
					url += "&isGive=" + this.query.isGive;
				}
				if (this.query.isBuke) {
					url += "&isBuke=" + this.query.isBuke;
				}
				if (this.query.studentName) {
					url += "&studentName=" + this.query.studentName;
				}
			
				this.axios.get(url).then(response => {



					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			weekName(wk) {

				let stName = "未知";
				this.weekItems.forEach((item, index) => {
					if (item.id == wk) {
						stName = item.weekName;

					}
				})
				return stName;
			},
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "到课";
				} else if (state === "2") {
					stName = "请假";
				} else if (state === "3") {
					stName = "旷课";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "2") {
					color = "warning";
				} else if (state === "3") {
					color = "error";
				}

				return color;
			},
			consumeTypeColor(state) {
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "2") {
					color = "green";
				}

				return color;
			},
			consumeTypeName(state) {
				let color = "未知";
				if (state === "1") {
					color = "扣课时";
				} else if (state === "2") {
					color = "扣金额";
				}

				return color;
			},

			getClassListForSelect(shopId) {

				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/class/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectClassList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getCourseListForSelect(shopId) {

				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/course/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectCourseList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getTeacherListForSelect(shopId) {

				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/teacher/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectTeacherList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			getClassroomListForSelect(shopId) {

				if (!shopId) {
					return
				}

				const that = this;
				let url = `/edu/shop/classroom/list/` + shopId;

				this.axios.get(url).then(response => {

					if (response.data["code"] === 200) {
						that.selectClassroomList = response.data["data"] ? response.data["data"] : [];
						return
					}

					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},

		}
	}
</script>

<style>
</style>
